import { PaginationList } from 'best-modules/components/server-table/types'
import { sendRequest } from 'best-modules/vue-utils'
import { Query } from 'best-modules/utils'
import type {
  Contractor,
  ContractorContact,
  ContractorCredentials,
} from '@/utils/types/contractor'

const contractorListUrl = (): string => '/json/contractor'

const contractorList = (
  query?: Query
): Promise<PaginationList<Contractor> | Contractor[]> => {
  return sendRequest({
    name: 'contractors',
    method: 'get',
    url: {
      url: contractorListUrl(),
      query,
    },
  })
}

const contractorSingle = (contractorId: number): Promise<Contractor> => {
  return sendRequest({
    name: 'contractorSingle',
    method: 'get',
    url: `/json/contractor/single/${contractorId}`,
  })
}

const contractorCreate = (
  credentials: ContractorCredentials
): Promise<Contractor> => {
  return sendRequest({
    name: 'contractorCreate',
    method: 'post',
    url: '/json/contractor/create',
    payload: credentials,
  })
}

const contractorUpdate = (
  contractorId: number,
  credentials: Partial<ContractorCredentials>
): Promise<Contractor> => {
  return sendRequest({
    name: 'contractorUpdate',
    method: 'post',
    url: `/json/contractor/update/${contractorId}`,
    payload: credentials,
  })
}

const contractorAddressCreate = (
  credentials: ContractorContact
): Promise<ContractorContact> => {
  return sendRequest({
    name: 'contractorAddressCreate',
    method: 'post',
    url: '/json/contractor/address/create',
    payload: credentials,
  })
}

const contractorAddressUpdate = (
  addressId: number,
  credentials: ContractorContact
): Promise<ContractorContact> => {
  return sendRequest({
    name: 'contractorAddressUpdate',
    method: 'post',
    url: `/json/contractor/address/update/${addressId}`,
    payload: credentials,
  })
}

const contractorAddressDelete = (addressId: number): Promise<void> => {
  return sendRequest({
    name: 'contractorAddressDelete',
    method: 'delete',
    url: `/json/contractor/address/delete/${addressId}`,
  })
}

const contractorPhoneCreate = (
  credentials: ContractorContact
): Promise<ContractorContact> => {
  return sendRequest({
    name: 'contractorPhoneCreate',
    method: 'post',
    url: '/json/contractor/phone/create',
    payload: credentials,
  })
}

const contractorPhoneUpdate = (
  phoneId: number,
  credentials: ContractorContact
): Promise<ContractorContact> => {
  return sendRequest({
    name: 'contractorPhoneUpdate',
    method: 'post',
    url: `/json/contractor/phone/update/${phoneId}`,
    payload: credentials,
  })
}

const contractorPhoneDelete = (phoneId: number): Promise<void> => {
  return sendRequest({
    name: 'contractorPhoneDelete',
    method: 'delete',
    url: `/json/contractor/phone/delete/${phoneId}`,
  })
}

const contractorEmailCreate = (
  credentials: ContractorContact
): Promise<ContractorContact> => {
  return sendRequest({
    name: 'contractorEmailCreate',
    method: 'post',
    url: '/json/contractor/email/create',
    payload: credentials,
  })
}

const contractorEmailUpdate = (
  emailId: number,
  credentials: ContractorContact
): Promise<ContractorContact> => {
  return sendRequest({
    name: 'contractorEmailUpdate',
    method: 'post',
    url: `/json/contractor/email/update/${emailId}`,
    payload: credentials,
  })
}

const contractorEmailDelete = (emailId: number): Promise<void> => {
  return sendRequest({
    name: 'contractorEmailDelete',
    method: 'delete',
    url: `/json/contractor/email/delete/${emailId}`,
  })
}

const contractorIntegrationInfo = (code: string): Promise<Contractor> => {
  return sendRequest({
    name: 'contractorIntegrationInfo',
    method: 'get',
    url: `/json/integration/getByInfo/${code}`,
  })
}

export {
  contractorListUrl,
  contractorList,
  contractorSingle,
  contractorCreate,
  contractorUpdate,
  contractorAddressCreate,
  contractorAddressUpdate,
  contractorAddressDelete,
  contractorPhoneCreate,
  contractorPhoneUpdate,
  contractorPhoneDelete,
  contractorEmailCreate,
  contractorEmailUpdate,
  contractorEmailDelete,
  contractorIntegrationInfo,
}
